import { NsCard } from 'components/common/ns-card/NsCard';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { NsPrice } from 'components/common/ns-price/NsPrice';
import { FUEL_TYPES } from 'config/app-config';

type CostBreakDownProps = {
  til: {
    unitRate: number;
    unitRateDay: number;
    unitRateNight: number;
    unitRateDayName: string;
    unitRateNightName: string;
    standingCharge: number;
    annualAmount: number;
    providedAnnualConsumption: number;
    providedAnnualConsumptionDay: number;
    providedAnnualConsumptionNight: number;
  };
  fuel: typeof FUEL_TYPES[keyof typeof FUEL_TYPES];
};

export const CostBreakDown = ({ til, fuel }: CostBreakDownProps) => {
  const decoration = fuel === FUEL_TYPES.ELECTRIC ? 'bulb' : 'gas';
  const testId = `${decoration}-cost-breakdown-tariff-details`;
  const fuelName = fuel === FUEL_TYPES.ELECTRIC ? 'Electricity' : 'Gas';

  if (!til) {
    return null;
  }

  return (
    <NsCard testId={testId} heading={fuelName} decoration={decoration}>
      <p>All costs are inclusive of VAT.</p>
      <NsDescriptionList>
        {[
          til.unitRate && {
            term: 'Unit rate',
            description: `${til.unitRate}p / kWh`
          },
          til.unitRateDay && {
            term: til.unitRateDayName,
            description: `${til.unitRateDay}p / kWh`
          },
          til.unitRateNight && {
            term: til.unitRateNightName,
            description: `${til.unitRateNight}p / kWh`
          },
          {
            term: 'Standing charge',
            description: `${til.standingCharge}p / day`
          },
          {
            term: 'Estimated annual cost',
            description: <NsPrice amount={til.annualAmount} />
          },
          {
            term: 'Estimated annual usage',
            description: (
              <>
                <span data-testid={`${fuel}-annual-consumption`}>
                  {til.providedAnnualConsumption
                    ? til.providedAnnualConsumption
                    : til.providedAnnualConsumptionDay +
                      til.providedAnnualConsumptionNight}
                </span>
                kWh
              </>
            )
          }
        ]}
      </NsDescriptionList>
    </NsCard>
  );
};
